exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dms-control__locations {\n\tmax-height: 430px;\n\toverflow-y: scroll;\n}\n\n.dms-control__buttons {\n\tmargin-top: 16px;\n\tclear: both;\n}\n\n.dms-control__button {\n\twidth: 100%;\n}\n\nweight-station-sign {\n\theight: auto;\n\tmargin-bottom: 16px;\n}\n\n@media screen and (max-width: 600px) {\n\t.col-xs-11 {\n\t\tmargin: 0 auto !important;\n\t}\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/weight-station-control/weight-station-control.component.css
// module id = ../../../../../src/app/weight-station-control/weight-station-control.component.css
// module chunks = main